import React, { useState, useEffect } from "react";
import { Edit, Delete, Visibility, FileCopy } from "@mui/icons-material";
import {
  Dialog as DialogMui,
  DialogContent,
  DialogTitle,
  Typography,
  TextField,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { generateClient } from "aws-amplify/api";
import {
  createManifest,
  createManifestItem,
  deleteManifest,
  updateManifest,
} from "../../graphql/mutations";
import { listManifestItems, listManifests } from "../../graphql/queries";
import { makeStyles } from "@mui/styles";
import { Button, Paper, Grid, Dialog, Card, styled } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import moment from "moment";
import CustomDataGrid from "../../components/CustomDataGrid";
import { listManifestsExt } from "../../graphqlExtensions/queries";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0),
    padding: theme.spacing(1),
  },
  dataGrid: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: "100%",
  },

  addItemsButton: {
    width: { xs: "100%", md: "200px" },
    backgroundColor: "#000d1a !important",
    color: "white",
    fontWeight: "bold",
    borderRadius: "8px",
  },
  greenCellStyle: {
    backgroundColor: "green",
    color: "white",
  },

  redCellStyle: {
    backgroundColor: "red",
    color: "white",
  },
  actionCell: {
    display: "flex",
    gap: 0,
  },
}));
const StyledCard = styled(Card)`
  margin: 20px;
  padding: 20px;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;
const StyledButton = styled(Button)`
  background-color: #000d1a !important;
  color: #fff !important;
  border-radius: 8px;
  &:hover {
    background-color: #000d1a !important;
  }
`;

const Mainfest = () => {
  const storedGroups = JSON.parse(
    localStorage.getItem("loggedInUserGroups") || "[]"
  );
  const userProfileId = JSON.parse(localStorage.getItem("userProfileId")) || "";
  const navigate = useNavigate();
  const classes = useStyles();
  const client = generateClient();
  const [manifestContents, setManifestContents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isDuplicateModalOpen, setIsDuplicateModalOpen] = useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [previousManifestToDeactivate, setPreviousManifestToDeactivate] =
    useState(null);

  const [selectedDates, setSelectedDates] = useState({
    contentStartDate: "",
    contentEndDate: "",
    newTitle: "",
    adminApproved: false,
    adminComment: "",
    carrierApproved: false,
    carrierComment: "",
  });
  const [currentRowData, setCurrentRowData] = useState(null);

  useEffect(() => {
    if (storedGroups[0] === "AdvertProvider") {
      navigate("/campaigns");
    }
    fetchManifestContents();
  }, []);

  const fetchManifestContents = async () => {
    try {
      setLoading(true);
      const response = await client.graphql({
        query: listManifestsExt,
      });
      const manifestList = response.data.listManifests.items;
      setManifestContents(manifestList);
    } catch (error) {
      console.error("Error fetching Manifest contents:", error);
    } finally {
      setLoading(false);
    }
  };
  const createManifestItemDuplicate = async (
    newManifestId,
    originalManifestId
  ) => {
    try {
      setLoading(true);
      const response = await client.graphql({
        query: listManifestItems,
        variables: {
          filter: {
            manifestID: { eq: originalManifestId },
          },
        },
      });
      const items = response.data.listManifestItems.items;

      for (const item of items) {
        const {
          id,
          createdAt,
          updatedAt,
          __typename,
          manifestID,
          ...itemDataForDuplication
        } = item;

        const duplicatedItemInput = {
          ...itemDataForDuplication,
          manifestID: newManifestId,
        };
        await client.graphql({
          query: createManifestItem,
          variables: { input: duplicatedItemInput },
        });
      }
    } catch (error) {
      console.error("Error creating duplicate Manifest items:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDuplicateClick = (rowData) => {
    setCurrentRowData(rowData);
    setSelectedDates({
      contentStartDate: "",
      contentEndDate: "",
      newTitle: `Copy of ${rowData.title}`,
      adminApproved: false,
      adminComment: "",
      carrierApproved: false,
      carrierComment: "",
    });
    setIsDuplicateModalOpen(true);
  };
  const handleDuplicate = async (rowData, selectedDates) => {
    const {
      id,
      updatedAt,
      carrier,
      createdAt,
      __typename,
      ...dataWithoutIdUpdatedAtTypename
    } = rowData;

    const duplicatedData = {
      ...dataWithoutIdUpdatedAtTypename,
      title: selectedDates.newTitle,
      adminApproved: false,
      adminComments: "",
      carrierApproved: false,
      carrierComments: "",
      contentStartDate: selectedDates.contentStartDate,
      contentEndDate: selectedDates.contentEndDate,
    };
    try {
      const data = await client.graphql({
        query: createManifest,
        variables: { input: duplicatedData },
      });

      const newManifestID = data.data.createManifest.id;
      await createManifestItemDuplicate(newManifestID, id);

      console.log("Condition to deactivate previous manifest met");

      await handleDeactivatePreviousManifest(id);
    } catch (error) {
      console.error("Error duplicating manifest:", error);
    }
  };

  const handleViewItems = async (id) => {
    navigate("manifest/items", {
      state: {
        manifestId: id,
      },
    });
  };
  const columns = [
    {
      field: "carrier.carrierName",
      headerName: "Carrier Name",
      headerClassName: "column-header",
      flex: 1,
      renderCell: (params) => params.row.carrier?.carrierName,
    },
    { field: "title", headerName: "Title", flex: 1 },
    storedGroups == "Admin"
      ? {
          field: "adminApproved",
          headerName: "Admin Approved",
          flex: 1,
          renderCell: (params) => (
            <div
              style={{
                color: params.value
                  ? params.value
                    ? "green"
                    : "red"
                  : "black",
              }}
            >
              {params.value ? "true" : "false"}
            </div>
          ),
        }
      : storedGroups == "Carrier"
      ? {
          field: "carrierApproved",
          headerName: "Carrier Approved",
          flex: 1,
          renderCell: (params) => (
            <div
              style={{
                color: params.value
                  ? params.value
                    ? "green"
                    : "red"
                  : "black",
              }}
            >
              {params.value ? "true" : "false"}
            </div>
          ),
        }
      : {},

    {
      field: "manifestDate",
      headerName: "Manifest Date",
      flex: 1,
      valueFormatter: (params) => moment(params.value).format("YYYY-MM-DD "),
    },
    {
      field: "contentStartDate",
      headerName: "Content Start Date",
      flex: 1,
      valueFormatter: (params) => moment(params.value).format("YYYY-MM-DD "),
    },
    {
      field: "contentEndDate",
      headerName: "Content End Date",
      flex: 1,
      valueFormatter: (params) => moment(params.value).format("YYYY-MM-DD"),
    },
    { field: "bucket", headerName: "Bucket", flex: 1 },
    { field: "isActive", headerName: "Active", flex: 1 },

    {
      field: "actions",
      headerName: "Actions",
      flex: 0,
      minWidth: 250,
      renderCell: (params) => (
        <div>
          <Button
            startIcon={<Visibility />}
            onClick={() => handleViewItems(params.row.id)}
          />
          <Button
            startIcon={<Edit />}
            onClick={() => updateManifestById(params.row.id)}
          />
          <Button
            startIcon={<Delete />}
            color="error"
            onClick={() => deleteManifestById(params.row.id)}
          />
          <Button
            startIcon={<FileCopy />}
            onClick={() => handleDuplicateClick(params.row)}
          />
        </div>
      ),
    },
  ];

  const deleteManifestById = async (manifestId) => {
    const client = generateClient();

    try {
      await client.graphql({
        query: deleteManifest,
        variables: { input: { id: manifestId } },
      });

      fetchManifestContents();
    } catch (err) {
      console.log("Error deleting manifest:", err);
    }
  };

  const updateManifestById = async (manifestId) => {
    navigate(`manifest/update`, {
      state: {
        userId: manifestId,
      },
    });
  };

  const handleDeactivatePreviousManifest = async (id) => {
    await client.graphql({
      query: updateManifest,
      variables: {
        input: {
          id: id,
          isActive: false,
        },
      },
    });
    await fetchManifestContents();
  };
  const DuplicateManifestModal = ({
    isOpen,
    onClose,
    onSubmit,
    initialData,
  }) => {
    const [localSelectedDates, setLocalSelectedDates] = useState(initialData);

    const handleDateChange = (e) => {
      const { name, value } = e.target;
      setLocalSelectedDates((prev) => ({ ...prev, [name]: value }));
    };

    const handleTitleChange = (e) => {
      const newTitle = e.target.value;
      setLocalSelectedDates((prev) => ({ ...prev, newTitle }));
    };

    const formatISODateString = (dateString) => {
      const date = new Date(dateString);
      date.setHours(10);
      date.setMinutes(28);
      date.setSeconds(0);
      date.setMilliseconds(0);
      return date.toISOString();
    };

    const handleSubmit = () => {
      const formattedStartDate = formatISODateString(
        localSelectedDates.contentStartDate
      );
      const formattedEndDate = formatISODateString(
        localSelectedDates.contentEndDate
      );
      onSubmit({
        ...localSelectedDates,
        contentStartDate: formattedStartDate,
        contentEndDate: formattedEndDate,
      });
      onClose();
    };

    return (
      <DialogMui
        open={isOpen}
        onClose={onClose}
        aria-labelledby="duplicate-manifest-modal-title"
      >
        <DialogTitle id="duplicate-manifest-modal-title">
          Duplicate Manifest
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" gutterBottom>
            Enter details for the new manifest.
          </Typography>
          <Box sx={{ "& > :not(style)": { mb: 2 } }}>
            <TextField
              margin="dense"
              label="New Title"
              type="text"
              fullWidth
              variant="outlined"
              value={localSelectedDates.newTitle}
              onChange={handleTitleChange}
            />
            <TextField
              margin="dense"
              label="Content Start Date"
              type="date"
              fullWidth
              variant="outlined"
              name="contentStartDate"
              InputLabelProps={{
                shrink: true,
              }}
              value={localSelectedDates.contentStartDate}
              onChange={handleDateChange}
            />
            <TextField
              margin="dense"
              label="Content End Date"
              type="date"
              fullWidth
              variant="outlined"
              name="contentEndDate"
              InputLabelProps={{
                shrink: true,
              }}
              value={localSelectedDates.contentEndDate}
              onChange={handleDateChange}
            />
          </Box>

          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            style={{ marginTop: "20px" }}
          >
            Submit
          </Button>
        </DialogContent>
      </DialogMui>
    );
  };

  return (
    <>
      <StyledButton
        variant="contained"
        onClick={() => navigate("manifest/create")}
      >
        Create Manifest
      </StyledButton>
      <Card sx={{ paddingY: 0, marginTop: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CustomDataGrid
              rows={manifestContents}
              columns={columns}
              pageSize={10}
              loading={loading}
            />
          </Grid>
        </Grid>
      </Card>

      <DuplicateManifestModal
        isOpen={isDuplicateModalOpen}
        onClose={() => setIsDuplicateModalOpen(false)}
        initialData={selectedDates}
        onSubmit={(selectedDates) => {
          handleDuplicate(currentRowData, selectedDates);
        }}
      />
    </>
  );
};

export default Mainfest;
